import {AfterViewInit, Component, DoCheck, OnInit} from '@angular/core';
import {Stage} from '../../../types/stage';
import {AddCompetitionCardService} from './service/add-competition-card.service';
import {AbstractControl, UntypedFormGroup} from '@angular/forms';
import {HttpHandlingService} from '../../../../api/services/http-handling.service';
import {CompetitorSimple} from '../../../types/competitor';
import { Round } from 'src/app/common/types/round';

@Component({
  selector: 'app-add-competition-card',
  templateUrl: './add-competition-card.component.html',
  styleUrls: ['./add-competition-card.component.css']
})
export class AddCompetitionCardComponent implements OnInit, AfterViewInit, DoCheck {

  competitionCardForm: UntypedFormGroup;
  rounds: Round[] = [];
  authors: number[] = [];
  authorsFullData: CompetitorSimple[] = [];
  activeAuthors: CompetitorSimple[] = [];

  constructor(private addCompetitionCardService: AddCompetitionCardService, private httpHandlingService: HttpHandlingService) {}

  panelOpenState: boolean = true;

  ngOnInit(): void {
    this.addCompetitionCardService.onReturnCompetition();
    this.competitionCardForm = this.addCompetitionCardService.competitionCardForm;
    this.authors = this.addCompetitionCardService.authors;
  }

  ngAfterViewInit(): void {
    this.addCompetitionCardService.getAvailableAuthors();
    this.authorsFullData = this.addCompetitionCardService.authorsFullData;
  }

  ngDoCheck(): void {
    this.rounds = this.addCompetitionCardService.rounds;
    this.authorsFullData = this.addCompetitionCardService.authorsFullData;
    this.activeAuthors = this.addCompetitionCardService.activeAuthors;
    if (this.authorsFullData.length === 0) {
      this.competitionCardForm.get('author').disable();
    } else {
      this.competitionCardForm.get('author').enable();
    }
  }

  /**
   * function for saving newly created competitions
   */
  onSaveCompetition(): void {
    this.addCompetitionCardService.onSaveCompetition();
  }

  /**
   * function for opening dialog for adding new round
   */
  onOpenNewRoundDialog(): void {
    this.addCompetitionCardService.onOpenNewRoundDialog();
  }

  /**
   * function for creating bundle of competition data and navigate to add stage window
   */
  onCreateStage(round: Round): void {
    this.addCompetitionCardService.onCreateStage(round);
  }

  /**
   * function for editing existing stage
   * @param stage for evaluation of specific stage for editing
   */
  onEditStage(round: Round, stage: Stage): void {
    this.addCompetitionCardService.onEditStage(round, stage);
  }

  /**
   * function for removing stage from competition
   * @param stage for evaluation of specific stage
   */
  onDeleteStage(round: Round, stage: Stage): void {
    this.addCompetitionCardService.onDeleteStage(round, stage);
  }

  /**
   * remove competition from local storage and return home
   */
  onCancel(): void {
    this.addCompetitionCardService.onCancel();
  }

  /**
   * function which provides error messages in the process of creating new competition
   * @param fieldControl with information about desired field (competition name)
   */
  getErrorMessage(fieldControl: AbstractControl): string {
    return this.httpHandlingService.handleUserErrorOutputAbstract(fieldControl);
  }

  /**
   * function for setting default value for dropdown based on comparing ids of competitors
   * @param formControlName for formControlName parameter
   * @param selectedOption for dropdown option values
   */
  compareCompetitors(formControlName: CompetitorSimple, selectedOption: CompetitorSimple): boolean {
    return formControlName && selectedOption && formControlName.id === selectedOption.id;
  }

  /**
   * function for disabling add additional competitor, if additional competitor
   * dropdown is empty
   */
  authorsFieldIsEmpty(): boolean {
    return this.competitionCardForm.get('author').value === null
      || this.competitionCardForm.get('author').value === '';
  }

  /**
   * function for evaluation of available competitors based on additional competitors
   */
  processAuthors(): void {
    this.addCompetitionCardService.processAuthors();
  }

  /**
   * function for removing desired competitor from additional competitors list
   * @param competitor for evaluation of competitor to delete
   */
  deleteActiveAuthor(competitor: CompetitorSimple): void {
    this.addCompetitionCardService.deleteActiveAuthor(competitor);
  }

  /**
   * function which provides error messages in the process of creating new competition
   * special function only for datepicker range input
   */
  getErrorMessageRangeDatePicker(): string {
    if (this.competitionCardForm.get('registrationEnabledFrom').invalid) {
      return this.httpHandlingService.handleUserErrorOutputAbstract(this.competitionCardForm.get('registrationEnabledFrom'));
    } else if (this.competitionCardForm.get('registrationEnabledTo').invalid) {
      return this.httpHandlingService.handleUserErrorOutputAbstract(this.competitionCardForm.get('registrationEnabledTo'));
    }
  }
}
